/* eslint-disable no-underscore-dangle */
import React, { useContext } from 'react';
import { CartContext, UPSELL_PRODUCTS } from '../context.jsx';
import { CheckboxSwitcher } from './checkbox-switcher.jsx';
import { checkIsRegularCartPage } from '../helpers/checkPage';

export const CartItemContainer = ({
  item,
  Component
}) => {
  const {
    toggleSubscription,
    updateItem,
    removeItem,
    isPending
  } = useContext(CartContext);
  const {
    customTitle,
    productTitle,
    flavor,
    subscriptionId,
    disablePurchaseType,
    price,
    subscriptionPrice,
    otpPrice
  } = window.variantDataSelector.getData(item.variant_id) || {};

  const defaultPrice = (price * item.quantity);
  const subscriptionImageSrc = window.variantDataSelector.getData(item.id)?.subscriptionImage;
  const imageSrc = window.variantDataSelector.getData(item.id)?.image;
  const isSubscribedItem = Boolean(item.properties._subscription_id);
  const isSubscriptionToggleVisible = Boolean(subscriptionId) && !disablePurchaseType;
  const image = isSubscribedItem ? subscriptionImageSrc : imageSrc;
  const discountPrice = (isSubscribedItem ? subscriptionPrice : otpPrice) * item.quantity;

  const isRegularCartPage = checkIsRegularCartPage();
  const isQuantityPending = isPending(`qty:${item.key}`);
  const isRemovePending = isPending(`remove:${item.key}`);
  const isSubscriptionPending = isPending(`sub:${item.key}`);

  const handleSubscriptionToggle = async (isSubscription) => {
    await toggleSubscription({
      item,
      isSubscription
    });
  };

  const handleQuantityChange = async (quantity) => {
    await updateItem({
      quantity,
      key: item.key,
      variantId: item.variant_id,
      isSubscription: isSubscribedItem
    });
  };

  const handleIncreaseQuantity = async () => {
    await handleQuantityChange(item.quantity + 1);
  };

  const handleDecreaseQuantity = async () => {
    if (item.quantity > 1) {
      await handleQuantityChange(item.quantity - 1);
    }
  };

  const handleRemoveItem = async () => {
    await removeItem({
      key: item.key,
      variantId: item.variant_id
    });
  };

  const checkboxSwitcher = isSubscriptionToggleVisible
    ? (
      <CheckboxSwitcher
        isPending={isSubscriptionPending}
        isSubscribed={isSubscribedItem}
        onChange={handleSubscriptionToggle}
      />
    ) : undefined;

  const isQuantityDisabled = isRegularCartPage && UPSELL_PRODUCTS.includes(item.variant_id);

  return (
    <Component
      checkboxSwitcher={checkboxSwitcher}
      defaultPrice={defaultPrice}
      discountPrice={discountPrice}
      flavor={flavor}
      image={image}
      isQuantityDisabled={isQuantityDisabled}
      isQuantityPending={isQuantityPending}
      isRemovePending={isRemovePending}
      itemQuantity={item.quantity}
      itemUrl={item.url}
      productTitle={customTitle || productTitle}
      variantTitle={item.variant_title}
      onDecreaseQuantity={handleDecreaseQuantity}
      onIncreaseQuantity={handleIncreaseQuantity}
      onRemoveItem={handleRemoveItem}
    />
  );
};
